/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum CaseFileZipTaskStatus {
    NotStarted = 0,
    Processing = 100,
    Complete = 200,
    Error = 300
}

export function CaseFileZipTaskStatusFromJSON(json: any): CaseFileZipTaskStatus {
    return CaseFileZipTaskStatusFromJSONTyped(json, false);
}

export function CaseFileZipTaskStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): CaseFileZipTaskStatus {
    return json as CaseFileZipTaskStatus;
}

export function CaseFileZipTaskStatusToJSON(value?: CaseFileZipTaskStatus | null): any {
    return value as any;
}

